import React from 'react';

const OutputSection = ({ rewrittenMessage, onCopy, copySuccess, isProcessing }) => {
    const hasContent = rewrittenMessage && typeof rewrittenMessage === 'string' && rewrittenMessage.trim().length > 0;

    return (
        <div className="flex-1 flex flex-col">
            <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-gray-700 dark:text-gray-300">Rewritten text</h3>
                <button
                    onClick={onCopy}
                    disabled={!hasContent}
                    className={`flex items-center gap-2 text-sm ${hasContent
                        ? (copySuccess ? 'text-primary-600 dark:text-primary-400' : 'text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100')
                        : 'text-gray-400 dark:text-gray-600 cursor-not-allowed'
                        }`}
                >
                    {copySuccess ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 6L9 17l-5-5" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                        </svg>
                    )}
                    {copySuccess ? 'Copied!' : 'Copy text'}
                </button>
            </div>

            <div className="relative flex-1 flex flex-col">
                <div className={`flex-1 border-2 ${hasContent ? 'border-primary-400 dark:border-primary-500' : 'border-gray-300 dark:border-gray-700'} rounded-lg p-4 font-mono text-sm bg-white dark:bg-gray-900`}>
                    {isProcessing ? (
                        <div className="flex flex-col items-center justify-center h-full text-center">
                            <div className="relative w-12 h-12 mb-4">
                                <div className="absolute inset-0 border-4 border-gray-200 dark:border-gray-700 rounded-full"></div>
                                <div className="absolute inset-0 border-4 border-primary-600 rounded-full animate-spin border-t-transparent"></div>
                            </div>
                            <p className="text-base text-gray-500 dark:text-gray-400">
                                Rewriting your text...
                            </p>
                        </div>
                    ) : hasContent ? (
                        <div className="whitespace-pre-wrap text-gray-800 dark:text-gray-100">
                            {rewrittenMessage}
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center h-full text-center">
                            <div className="bg-gray-50 dark:bg-gray-800 rounded-full p-6 mb-4">
                                <span className="w-8 h-8 text-primary-600 dark:text-primary-400" >
                                    <i class="fa-solid fa-wand-magic-sparkles"></i>
                                </span>
                            </div>
                            <p className="text-base text-gray-500 dark:text-gray-400 max-w-sm">
                                Your rewritten text will appear here
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OutputSection;



